<template>
  <div>
    <h1>Grade Comparisons</h1>
    <p class="text-muted font-weight-bold">
      Compare performance across grade levels
    </p>
    <hr />

    <!-- Filters -->
    <b-row class="mb-2">
      <b-col md="3" sm="6">
        <v-select
          v-model="selectedSubject"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="label"
          :options="['All Subjects', 'Math', 'ELA', 'Science']"
          :clearable="false"
          class="bg-white"
        />
      </b-col>
      <b-col md="3" sm="6">
        <v-select
          v-model="selectedYear"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="label"
          :options="['Current Year', '2025', '2024']"
          :clearable="false"
          class="bg-white"
        />
      </b-col>
    </b-row>

    <!-- Summary Cards -->
    <b-row class="hover-card">
      <b-col v-for="(stat, index) in gradeSummaries" :key="index" md="2" sm="4">
        <b-card no-body class="text-center cursor-pointer shadow-sm">
          <b-card-body class="p-2">
            <h6 class="mb-1">{{ stat.grade }}</h6>
            <h2 class="font-weight-bolder text-dark mb-1">{{ stat.score }}</h2>
            <div class="d-flex align-items-center justify-content-center small">
              <feather-icon icon="UsersIcon" size="14" class="mr-50" />
              <span>{{ stat.students }} students</span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Charts Row -->
    <b-row class="match-height">
      <!-- Subject Performance Chart -->
      <b-col md="8">
        <b-card no-body class="h-100 shadow-sm">
          <b-card-header>
            <b-card-title>Subject Performance by Grade</b-card-title>
          </b-card-header>
          <b-card-body>
            <vue-apex-charts
              type="bar"
              height="350"
              :options="subjectChartOptions"
              :series="subjectChartSeries"
            />
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Radar Chart -->
      <b-col md="4">
        <b-card no-body class="h-100 shadow-sm">
          <b-card-header>
            <b-card-title>5th Grade vs District Average</b-card-title>
          </b-card-header>
          <b-card-body>
            <vue-apex-charts
              type="radar"
              height="350"
              :options="radarChartOptions"
              :series="radarChartSeries"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import vSelect from "vue-select";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    VueApexCharts,
    vSelect,
  },
  data() {
    return {
      selectedSubject: "All Subjects",
      selectedYear: "Current Year",
      gradeSummaries: [
        { grade: "3rd Grade", score: "71%", students: "85" },
        { grade: "4th Grade", score: "76%", students: "82" },
        { grade: "5th Grade", score: "75%", students: "88" },
        { grade: "6th Grade", score: "70%", students: "79" },
        { grade: "7th Grade", score: "68%", students: "76" },
        { grade: "8th Grade", score: "73%", students: "77" },
      ],
      // Subject Performance Chart (Bar)
      subjectChartSeries: [
        { name: "Math", data: [70, 78, 75, 71, 69, 74] },
        { name: "ELA", data: [74, 79, 76, 73, 71, 75] },
        { name: "Science", data: [68, 74, 76, 69, 67, 72] },
        { name: "Social Studies", data: [65, 71, 74, 66, 65, 70] },
      ],
      subjectChartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        colors: ["#1e1e2d", "#00cfe8", "#28c76f", "#ff9f43"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "70%",
            endingShape: "rounded",
          },
        },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
          categories: [
            "3rd Grade",
            "4th Grade",
            "5th Grade",
            "6th Grade",
            "7th Grade",
            "8th Grade",
          ],
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          min: 60,
          max: 85,
        },
        fill: { opacity: 1 },
        legend: { show: false },
        grid: {
          borderColor: "#f1f1f1",
          yaxis: { lines: { show: true } },
        },
      },
      // Radar Chart
      radarChartSeries: [
        {
          name: "5th Grade",
          data: [80, 76, 72, 74, 80],
        },
        {
          name: "District Avg",
          data: [75, 78, 70, 68, 75],
        },
      ],
      radarChartOptions: {
        chart: {
          type: "radar",
          toolbar: { show: false },
        },
        labels: ["Math", "ELA", "Science", "Social Studies", "Writing"],
        stroke: {
          width: 2,
          colors: ["#1e1e2d", "#a0a0a0"],
        },
        colors: ["#1e1e2d", "#e4e6eb"],
        fill: { opacity: 0.2 },
        markers: { size: 0 },
        yaxis: { show: false },
        legend: {
          position: "bottom",
        },
      },
    };
  },
};
</script>

<style scoped></style>
